goog.provide('el8.appchart.dialog.problemHx');

goog.require('el8.appchart.actions.problems');
goog.require('el8.appchart.dialog.addEditProblem');
goog.require('el8.template.appchart.dialog.problemHx');
goog.require('el8.uiwidget.Component');
goog.require('el8.uiwidget.ComponentDialog');


el8.appchart.dialog.problemHx = (function() {

    var actionsMenu = null;

    var that = new el8.uiwidget.ComponentDialog({
        title: "Problem History",
        height: function() {
            return el8.app.pageLayout.getChartInnerHeight();
        },
        width: 570,
        contentFn: el8.template.appchart.dialog.problemHx.content
    });

    var component = new el8.uiwidget.Component({
        dataRenderers: [
            {
                entitySet: el8.ptdata.ptProblems,
                renderFn: function() {
                    // don't re-render when the dialog isn't open
                    if (!that.isOpen()) { return; }

                    var allProblems = el8.ptdata.ptProblems.sorted();
                    var activeProblems = [];
                    var resolvedProblems = [];
                    var controlledProblems = [];

                    for (var i=0; i<allProblems.length; i++) {
                        var curr = allProblems[i];
                        if (curr.getStatus() === 'Resolved') {
                            resolvedProblems.push(curr);
                        } else if (curr.getStatus() === 'Controlled') {
                            controlledProblems.push(curr);
                        } else {
                            activeProblems.push(curr);
                        }
                    }

                    var isShowDualCodingDisabled = !el8.data.currUser.isShowDualCodingEnabled();

                    $('.active-problems-section', that.getContentElt()).html(
                        el8.template.appchart.dialog.problemHx.problemList({
                            problems: activeProblems.map(el8.model.toSoyMapFn),
                            isDocumentedAsNone: el8.ptdata.ptProblems.isDocumentedAsNone(),
                            showDualCodingDisabled: isShowDualCodingDisabled
                        })
                    );
                    $('.controlled-problems-section', that.getContentElt()).html(
                        el8.template.appchart.dialog.problemHx.problemList({
                            problems: controlledProblems.map(el8.model.toSoyMapFn),
                            isDocumentedAsNone: el8.ptdata.ptProblems.isDocumentedAsNone(),
                            showDualCodingDisabled: isShowDualCodingDisabled
                        })
                    );
                    $('.resolved-problems-section', that.getContentElt()).html(
                        el8.template.appchart.dialog.problemHx.problemList({
                            problems: resolvedProblems.map(el8.model.toSoyMapFn),
                            isDocumentedAsNone: el8.ptdata.ptProblems.isDocumentedAsNone(),
                            showDualCodingDisabled: isShowDualCodingDisabled
                        })
                    );

                    that.adjustPosition();
                },
                events: [{eventName: 'all'}]
            }
        ]
    });
    that.setComponent(component);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.more-actions-trigger',  function() {
            var itemId = $(this).data('id');

            var menu;
            if (itemId) {
                var ptProblem = el8.ptdata.ptProblems.getById(itemId);
                menu = el8.appchart.actions.problems({ item: ptProblem });
            } else {
                menu = el8.appchart.actions.problems(null);
            }

            actionsMenu.display(
                $(this),
                null,
                { top: 17, left: 0 },
                menu
            );
            that.adjustHeight();
            return false;

        }).on('click', '.add-problem-trigger',  function() {
            el8.appchart.dialog.addEditProblem.show();
        });
    };

    var super_show = that.show;
    that.show = function() {
        super_show.call(that);

        if (!actionsMenu) {
            actionsMenu = new el8.uiwidget.NewActionsMenu({
                container: that.getContentElt(),
                anchorTop: $('.el8DialogContainer', that.getContentElt()),
                menuId: 'problem-hx-actions-menu'
            });
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        actionsMenu.destroy();
        actionsMenu = null;
    };

    return that;

})();
